import { render, staticRenderFns } from "./friendRequest.vue?vue&type=template&id=19caef7a&scoped=true&lang=pug&"
import script from "./friendRequest.vue?vue&type=script&lang=js&"
export * from "./friendRequest.vue?vue&type=script&lang=js&"
import style0 from "./friendRequest.vue?vue&type=style&index=0&id=19caef7a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19caef7a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('19caef7a')) {
      api.createRecord('19caef7a', component.options)
    } else {
      api.reload('19caef7a', component.options)
    }
    module.hot.accept("./friendRequest.vue?vue&type=template&id=19caef7a&scoped=true&lang=pug&", function () {
      api.rerender('19caef7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/friend/friendRequest.vue"
export default component.exports